var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "input-base",
    {
      attrs: {
        overlap: _vm.overlap,
        small: _vm.small,
        transparent: _vm.transparent,
        stretched: _vm.stretched,
        slimmer: _vm.slimmer
      },
      scopedSlots: _vm._u([
        {
          key: "input",
          fn: function(ref) {
            var params = ref.params
            return _c("div", {}, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.value,
                    expression: "value"
                  }
                ],
                class: _vm.getInnerStyle + " " + _vm.errorStyle(params),
                attrs: {
                  type: "number",
                  disabled: _vm.dissabled,
                  placeholder: _vm.getPlaceholderLabel,
                  id: _vm.identification,
                  name: _vm.inputName
                },
                domProps: { value: _vm.value },
                on: {
                  keyup: function($event) {
                    return _vm.sendUpdate()
                  },
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.value = $event.target.value
                  }
                }
              })
            ])
          }
        }
      ])
    },
    [
      !!_vm.inputLabel
        ? _c(
            "label",
            { attrs: { slot: "label", for: _vm.inputName }, slot: "label" },
            [_vm._v("\n\n    " + _vm._s(_vm.inputLabel) + "\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._v(" "),
      _vm.getFootnote
        ? _c("span", { attrs: { slot: "footnote" }, slot: "footnote" }, [
            _vm._v("\n\n    " + _vm._s(_vm.getFootnote) + "\n  ")
          ])
        : _vm._e(),
      _vm._v(" "),
      !!_vm.iconRight
        ? _c("q-icon", {
            attrs: {
              slot: "icon-right",
              allowSelfUpdate: false,
              width: "15px",
              name: _vm.iconRight
            },
            slot: "icon-right"
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f1822be8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f1822be8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/standard/input/InputNumber.vue
// module id = null
// module chunks = 